import { recognizeRunFilters } from "@redotech/redo-recognize-common/run-filters";
import * as z from "zod";

export const getRecognizeRunFilters = {
  name: "getRecognizeRunFilters" as const,
  input: z.null(),
  output: recognizeRunFilters,
};

export const saveRecognizeRunFilters = {
  name: "saveRecognizeRunFilters" as const,
  input: recognizeRunFilters,
  output: recognizeRunFilters,
};
